import { memo } from 'react'

import RoundRobinPage, { TEST_ID } from './RoundRobin'

const RoundRobin = memo(RoundRobinPage)

export { TEST_ID }

export default RoundRobin
